export default __webpack_public_path__ + "static/2.5.1/media/republicOfPoland.502b999c.svg";